import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  encapsulation:ViewEncapsulation.None,
  selector: 'app-paybybank-popup',
  templateUrl: './paybybank-popup.component.html',
  styleUrl: './paybybank-popup.component.css'
})
export class PaybybankPopupComponent {

  constructor(public dialogRef: MatDialogRef<PaybybankPopupComponent>){
    dialogRef.disableClose = true;
  }

  

  exit(){
    this.dialogRef.close();
  }

}
